<div class="pt-6">
  <aiwyn-logo [height]="60"></aiwyn-logo>
</div>

<div class="authentication-body">
  <h2>Check your inbox!</h2>

  <img
    src="assets/check-inbox.png"
    width="129"
    height="129"
    alt="logo"
    class="login__logo"
  >

  <p class="body-300 text-center">
    We just sent a password reset email to: <strong>{{ email }}</strong>.
  </p>

  <p class="body-400 text-center">
    Once you have verified your email address, you can use it to
    <span (click)='logIn()' class="mt-6 text-link">log in</span>.
  </p>
</div>

<app-full-client-portal-footer class="px-6 pb-6"></app-full-client-portal-footer>
